var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-bar"},[_c('button',{staticClass:"navigation__button navigation__button--previous",on:{"click":_vm.navigatePrevious}},[_vm._v("\n    🠔 Arrow back\n  ")]),_c('button',{staticClass:"navigation__button navigation__button--next",on:{"click":_vm.navigateNext}},[_vm._v("\n    🠔 Arrow next\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }